function AboutPage() {
  return (
    <div className="page">
      <h1 className="page-title">About Nuvolem</h1>

      <div className="page-section">
        <p>
          Nuvolem Software Solutions is a startup focused on building tools for the
          Architecture, Engineering, and Construction (AEC) industry. Our mission is to
          improve productivity and streamline workflows for AEC professionals through
          purpose-built software.
        </p>
        <p>
          We develop applications and plugins that integrate directly with industry-standard
          platforms, including Autodesk Revit and AutoCAD. Our tools are designed to fit
          naturally into the way AEC teams already work, reducing friction and letting
          professionals focus on what they do best.
        </p>
        <p>
          We are actively developing our product lineup. Check back soon for updates on
          our latest releases.
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
